/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ExerciseDto } from './exercise-dto';
import { PaginationMetaDto } from './pagination-meta-dto';
 /**
 *
 *
 * @export
 * @interface ExercisePaginatedResponseDto
 */
export interface ExercisePaginatedResponseDto {

    /**
     * @type {Array<ExerciseDto>}
     * @memberof ExercisePaginatedResponseDto
     */
    data: Array<ExerciseDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof ExercisePaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
